import i18next from 'i18next';

i18next.addResources('es', 'EmptyFilesResult', {
  checkInformation: 'Verifique la información ingresada',
  noResults: 'No se encontraron resultados',
  noFiles: 'No hay expedientes para mostrar'
});
